import { Pipe, PipeTransform } from '@angular/core';
import { CNAESecundaria } from '../cnae-secundaria';
import { CNAEViewer } from '../adapters';

@Pipe({
    name: 'cnaeSecundariasViewerMap',
    pure: false
})
/** Pipe para realizar o map da interface CNAESecundaria para interface CNAEViewer */
export class CNAESecundariasViewerMapPipe implements PipeTransform {
    transform(cnaesSecundarias: CNAESecundaria[] = []): CNAEViewer[] {
        if (!cnaesSecundarias || cnaesSecundarias.length === 0) {
            return [];
        }

        return cnaesSecundarias
            .filter(cnaeSecundaria => cnaeSecundaria.cnae)
            .map(cnaeSecundaria => {
                const cnaeView: CNAEViewer = {
                    id: cnaeSecundaria.cnae.id,
                    codigo: cnaeSecundaria.cnae.codigo,
                    nome: cnaeSecundaria.cnae.nome,
                    apelido: cnaeSecundaria.cnae.apelido,
                    secundaria: true
                };
                return cnaeView;
            });
    }
}
